// extracted by mini-css-extract-plugin
export default {"container":"SidebarItem_container__aPlr7","isSelected":"SidebarItem_isSelected__Rw+G6"};